module.exports = __webpack_public_path__ + "img/cn.58efb3f0.svg";